import gql from 'graphql-tag';

const NAME = 'compositions_CaseInboundProgramPanel_caseQuery';

export default gql`
  query ${NAME} (
    $caseNumber: String!
  ) {
    case (
      caseNumber: $caseNumber
    ) {
      id
      inboundProgramNumber {
        id
        billTo
        customerName
        inboundProgramAccountType
        locations {
          ... on Dealer {
            billTo
            displayAddress {
              city
              province
            }
            id
            name
            shipTo
          }
          ... on Customer {
            billTo
            city
            id
            name
            shipTo
            state
          }
        }
        tollFreeNumber
        requiresValidationForAssetTypes {
          type
          requirements
        }
      }
      inboundProgramShipTo
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseInboundProgramPanel/withCase/caseQuery.js